import { msalInstance } from "./msal"; // <-- adjust to your project

const apiScope = "api://85abf92b-14d7-4dcb-86ca-acd8231a739d/access_as_user";

export async function getImplementationManagerToken() {
  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No active MSAL account. User is not logged in.");
  }

  const tokenResponse = await msalInstance.acquireTokenSilent({
    account,
    scopes: [apiScope],
  });

  return tokenResponse.accessToken;
}
